import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AssessmentList.css";
import { API_URL } from "../config";

const AssessmentList = ({ onSelectAssessment }) => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Function to get the auth header for API calls
  const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  useEffect(() => {
    const fetchAssessments = async () => {
      try {
        const response = await fetch(`${API_URL}/api/assessments`, {
          headers: {
            ...getAuthHeader(),
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            navigate("/");
            return;
          }
          throw new Error("Failed to fetch assessments");
        }

        const data = await response.json();
        // Sort assessments alphabetically by ID
        const sortedAssessments = data.assessments.sort((a, b) =>
          a.id.localeCompare(b.id, undefined, {
            numeric: true,
            sensitivity: "base",
          })
        );
        setAssessments(sortedAssessments);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAssessments();
  }, [navigate]);

  if (loading) return <div className="loading">Loading assessments...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="assessments-container">
      <h2>Available Assessments</h2>
      <div className="assessments-list">
        {assessments.map((assessment) => (
          <div
            key={assessment.id}
            className="assessment-item"
            onClick={() => onSelectAssessment(assessment)}
          >
            <span className="assessment-title">{assessment.id}</span>
            <span className="question-count">
              {assessment.questionCount} Questions
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssessmentList;
